export const PricingCategoriesResource = {
  name: "Pricing Categories",
  path: "/inventory/pricelist/pricing-categories",
  access: ["read-pricingcategories"],
};
